import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDPhVjstEA8wDqZpINjfW_iYxNoCpGmsMg",
  authDomain: "the-heads-wedding.firebaseapp.com",
  projectId: "the-heads-wedding",
  storageBucket: "the-heads-wedding.firebasestorage.app",
  messagingSenderId: "984067130805",
  appId: "1:984067130805:web:8a13d769286481ac6545fc",
  measurementId: "G-SPCBBGXG2J",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
